import { render, staticRenderFns } from "./ApplicantForm.vue?vue&type=template&id=91ef0f4e&"
import script from "./ApplicantForm.vue?vue&type=script&lang=js&"
export * from "./ApplicantForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports